module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/02-21fa1b2fe620d4130060a1cba625dd47.jpg";